// mapeia tipos de ação para rótulos em pt-BR
export function mapActionType(
  translate: (item: string) => string,
  requestType?: { readonly type?: 'CREATE' | 'EDIT' | 'DELETE' | string }
): string {
  const raw = String(requestType?.type || '').toUpperCase()

  if (raw === 'CREATE' || raw === 'POST') return translate('CREATE')
  if (raw === 'PUT' || raw === 'UPDATE') return translate('EDIT')
  if (raw === 'DELETE' || raw === 'REMOVED') return translate('DELETE')

  return raw ? raw : ''
}

export function buildReportTypeOptions(translate: (item: string) => string) {
  return [
    { value: 'create', label: translate('CREATE') },
    { value: 'edit', label: translate('EDIT') },
    { value: 'delete', label: translate('DELETE') },
  ]
}
